const fixReviewLinks = () => {
  for (const badge of document.querySelectorAll('.jdgm-all-reviews-text')) {
    for (const link of badge.querySelectorAll('a')) {
      link.href = '/pages/reviews';
      link.style.pointerEvents = 'auto';
      const label = badge.querySelector('.jdgm-all-reviews-text__text')?.textContent.trim();
      if (label) link.setAttribute('aria-label', label);
    }
  }
};
fixReviewLinks();
const observer = new MutationObserver(fixReviewLinks);
observer.observe(document.body, {childList: true, subtree: true});
window.addEventListener('click', event => {
  const badge = event.target instanceof Element ? event.target.closest('.jdgm-all-reviews-text') : null;
  if (!badge || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign('/pages/reviews');
}, true);

